import {Component, OnInit} from '@angular/core';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {AbstractBffApi, KeystringValueInterface, NewsInterface} from '../../../models/sharedinterface';
import {ActivatedRoute} from '@angular/router';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {GlobalsService} from '../../../shared/services/globals.service';

@Component({
  selector: 'app-welcome-interface',
  templateUrl: './welcome-interface.component.html',
  styleUrls: ['./welcome-interface.component.scss']
})
export class WelcomeInterfaceComponent implements OnInit {
  // news: MandantNewsInterface[];

  // images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);

  currentNews: NewsInterface[];

  currentlanguage: KeystringValueInterface;

  // welcomebackgroundcolor: string;

  bffapi: AbstractBffApi;

  constructor(private apifactory: ApiFactoryService,
              private shareddata: ShareddataService,
              private route: ActivatedRoute,
              private globalsservice: GlobalsService) {

    this.currentNews = [];

    this.bffapi = this.apifactory.createBffApi();

    // this.shareddata.currentNews.subscribe(news => this.news = news);

    this.shareddata.currentlanguage$.subscribe((data) => {

      this.currentlanguage = data;
      const query = this.bffapi.getmandantnews2(this.currentlanguage.key);
      query.subscribe((data) => {
        this.currentNews = data.results;
      });

    });
    // this.shareddata.currentNews$.subscribe( (data) => { this.currentNews = data; });
  }

  ngOnInit(): void {

  } // ngOnInit


  // lnginterfacechange(newlng) {
  //   console.log(newlng.key);
  //   // let toolid = this.route.snapshot.paramMap.get('toolid');
  //   const toolkey = this.route.snapshot.paramMap.get('toolkey');
  //   let toolid = '6';
  //
  //
  //   // @todo new param to set
  //   const origin = window.location.hostname;
  //   const simorigin = this.globalsservice.getSimorigin();
  //
  //   const bffapi = this.apifactory.createBffApi();
  //   let query = bffapi.getmandantnews(toolid, newlng.key, origin, simorigin);
  //   query.subscribe((news) => {
  //
  //     this.news = news['results'];
  //     console.log(this.news);
  //   });
  // } // lnginterfacechange


}
